import { useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import React from 'react';
import { ReactElement } from 'react';

interface useSummaryNextStepsItemHelperOutput {
	MainIcon: ReactElement;
	LinkIcon?: ReactElement;
}

export const useSummaryNextStepsItemHelper = (
	mainIcon: ReactElement,
	linkIcon?: ReactElement
): useSummaryNextStepsItemHelperOutput => {
	const mainIconProps = mainIcon.props;
	const linkIconProps = linkIcon?.props;

	const { palette } = useTheme();

	const MainIcon = React.cloneElement(mainIcon, {
		...mainIconProps,
		style: { marginRight: rem(24), flexShrink: 0, ...mainIconProps.style },
		fill: mainIconProps.fill || palette.global.ui1,
		width: mainIconProps.width || rem(48),
		height: mainIconProps.height || rem(48),
	});

	const LinkIcon = linkIcon
		? React.cloneElement(linkIcon, {
				...linkIconProps,
				style: { ...linkIconProps.style },
				fill: linkIconProps.fill || palette.global.ui1,
				width: linkIconProps.width || rem(24),
				height: linkIconProps.height || rem(24),
		  })
		: undefined;

	return {
		MainIcon,
		LinkIcon,
	};
};
